<template>
    <modal name="create_addition" height="auto" scrollable adaptive>
        <app-card :title="$t('Create additional equipment')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <addition-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import AdditionService from '@services/addition.service';
import AdditionForm from './components/Form';

export default {
    data() {
        return {
            form: {
                name: {
                    et: '',
                    en:''
                },
                comments: {
                    et: '',
                    en:''
                },
                img: {},
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    AdditionService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setAddition', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_addition');
        }
    },
    components: {
        AdditionForm
    }
};
</script>
